import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { reportsApi } from "@/api/reports";
import type { AddContractBonusPayload } from "@/types/reports";

export const reportKeys = {
  all: ["reports"] as const,
  companyResults: (year: number, month: number | null) =>
    [...reportKeys.all, "company-results", year, month] as const,
};

/** `month` null = the whole year. */
export function useCompanyResults(year: number, month: number | null) {
  return useQuery({
    queryKey: reportKeys.companyResults(year, month),
    queryFn: () => reportsApi.getCompanyResults(year, month),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
}

export function useAddContractBonus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AddContractBonusPayload) =>
      reportsApi.addContractBonus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reportKeys.all });
    },
  });
}

export function useDeleteContractBonus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => reportsApi.deleteContractBonus(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reportKeys.all });
    },
  });
}
